import { useMemo } from 'react';

import { useViewerProfile } from './useViewerProfile';

import { USER_ROLE_OPTIONS, type UserRole } from '@/types/users';

const ENTIRE_COMPANY_SCOPE_ROLES = new Set<UserRole>(
  USER_ROLE_OPTIONS.filter((role): role is Exclude<UserRole, 'user'> => role !== 'user')
);

const roleAllowsEntireCompanyScope = (role: UserRole | null): boolean => {
  if (!role) return false;
  return ENTIRE_COMPANY_SCOPE_ROLES.has(role);
};

export const useViewerCanSeeEntireCompanyScope = (): {
  canSeeEntireCompanyScope: boolean;
  isEntireCompanyScopeAccessResolved: boolean;
} => {
  const { role } = useViewerProfile();
  const canSeeEntireCompanyScope = useMemo(() => roleAllowsEntireCompanyScope(role), [role]);

  return {
    canSeeEntireCompanyScope,
    isEntireCompanyScopeAccessResolved: true,
  };
};
